import { serialize } from 'object-to-formdata'
import snakecaseKeys from 'snakecase-keys'
import axiosIns from '@/plugins/axios'

export default {
  getItems() {
    return axiosIns.get('/waiter/items')
  },
  createItem({
    name,
    sellingPrice,
    costPrice,
    defaultTaxCharge = 'normal',
    recipientRequired = false,
    vendibleTaggingsAttributes = [],
  }) {
    const formData = serialize(snakecaseKeys({
      item: {
        name,
        sellingPrice,
        costPrice,
        defaultTaxCharge,
        recipientRequired,
        vendibleTaggingsAttributes,
      },
    }))

    return axiosIns.post('/waiter/items', formData)
  },
  updateItem({
    id,
    name,
    sellingPrice,
    costPrice,
    defaultTaxCharge = 'normal',
    recipientRequired = false,
    vendibleTaggingsAttributes = [],
  }) {
    const formData = serialize(snakecaseKeys({
      item: {
        name,
        sellingPrice,
        costPrice,
        defaultTaxCharge,
        recipientRequired,
        vendibleTaggingsAttributes,
      },
    }))

    return axiosIns.put(`/waiter/items/${id}`, formData)
  },
  deleteItem(id) {
    return axiosIns.delete(`/waiter/items/${id}`)
  },
  updatePositions(idAndPositions) {
    const formData = serialize(snakecaseKeys({
      items: idAndPositions,
    }))

    return axiosIns.put('/waiter/items/update_positions', formData)
  },
}
